var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.643 0C8.594 0.001 9.5 0.455 10.068 1.214L10.979 2.426C11.268 2.81 11.727 3.039 12.207 3.04H15.036C18.898 3.04 20.697 5.019 20.697 9.268L20.669 14.235C20.668 18.203 18.202 20.669 14.232 20.669H6.45C2.472 20.669 0 18.202 0 14.232V6.433C0 2.164 1.899 0 5.643 0H7.643ZM7.642 1.5H5.643C2.739 1.5 1.5 2.976 1.5 6.433V14.232C1.5 17.416 3.258 19.169 6.45 19.169H14.232C17.416 19.169 19.169 17.416 19.169 14.232V14.229L19.197 9.264C19.197 5.865 18.031 4.54 15.036 4.54H12.206C11.257 4.539 10.351 4.086 9.781 3.328L8.868 2.114C8.581 1.729 8.122 1.501 7.642 1.5ZM14.7162 12.2128C15.1302 12.2128 15.4662 12.5488 15.4662 12.9628C15.4662 13.3768 15.1302 13.7128 14.7162 13.7128H5.9812C5.5672 13.7128 5.2312 13.3768 5.2312 12.9628C5.2312 12.5488 5.5672 12.2128 5.9812 12.2128H14.7162Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.cf37a5a17ded15225bb05c6aedfa672b.svg";
export { ForwardRef as ReactComponent };